import { FC } from 'react';

import { useDroppable } from '@dnd-kit/core';
import { CirclePlusIcon } from '@smartshell/ui-kit';
import classNames from 'classnames';

import { isMapEntityActive } from '../../dragIds';
import s from './Droppable.module.scss';
import { IDroppableProps } from './intefaces';

export const Droppable: FC<IDroppableProps> = ({
  selected,
  children,
  id,
  disabled,
  childrenId,
  hostId,
  hasConflict,
  isEdit,
  hidden,
}) => {
  const { isOver, setNodeRef, active } = useDroppable({
    id,
    disabled,
  });

  return (
    <div
      ref={setNodeRef}
      data-droppable-id={id}
      data-item-id={childrenId}
      data-host-id={hostId ?? undefined}
      className={classNames(
        s.Droppable,
        isOver && s.over,
        childrenId &&
          !isMapEntityActive(
            active?.id,
            hostId != null ? 'host' : 'object',
            Number(childrenId)
          ) &&
          s.dropped,
        !disabled && s.canAdd,
        selected && s.selected,
        hasConflict && isEdit && s.conflict_edit,
        hasConflict && !isEdit && s.conflict,
        hidden && s.hidden
      )}
    >
      {!childrenId && <CirclePlusIcon className={s.plus} color="link-info" />}

      {children}
    </div>
  );
};
